// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__sx6g4","label":"Radio_label__149to","checkMark":"Radio_checkMark__1QZ8h","disabled":"Radio_disabled__i3mFB"};